var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24796 15.1663C4.29463 15.1663 1.0813 11.953 1.0813 7.99967C1.0813 4.04634 4.29463 0.833008 8.24796 0.833008C12.2013 0.833008 15.4146 4.04634 15.4146 7.99967C15.4146 11.953 12.2013 15.1663 8.24796 15.1663ZM8.24796 1.83301C4.84797 1.83301 2.0813 4.59967 2.0813 7.99967C2.0813 11.3997 4.84797 14.1663 8.24796 14.1663C11.648 14.1663 14.4146 11.3997 14.4146 7.99967C14.4146 4.59967 11.648 1.83301 8.24796 1.83301Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36088 10.3859C6.23422 10.3859 6.10755 10.3393 6.00755 10.2393C5.81422 10.0459 5.81422 9.72592 6.00755 9.53259L9.78088 5.75926C9.97422 5.56592 10.2942 5.56592 10.4875 5.75926C10.6809 5.95259 10.6809 6.27259 10.4875 6.46592L6.71422 10.2393C6.62088 10.3393 6.48755 10.3859 6.36088 10.3859Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1342 10.3859C10.0075 10.3859 9.88088 10.3393 9.78088 10.2393L6.00755 6.46592C5.81422 6.27259 5.81422 5.95259 6.00755 5.75926C6.20088 5.56592 6.52088 5.56592 6.71422 5.75926L10.4875 9.53259C10.6809 9.72592 10.6809 10.0459 10.4875 10.2393C10.3875 10.3393 10.2609 10.3859 10.1342 10.3859Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.380fb892784b42d53a4347f170a9c401.svg";
export { ForwardRef as ReactComponent };